// 写作中心
export default {
    path: "/writingCenter",
    name: "writingCenter",
    component: () => import("@/views/writingCenter/index.vue"),
    children: [
        {
            path: "/writingCenter/intelligentTopic",
            name: "writingCenter-intelligentTopic",
            component: () => import("@/views/writingCenter/intelligentTopic/index.vue"),
            meta: {
                isLogin: true,
            },
        },
        {
            path: "/writingCenter/myWriting",
            name: "writingCenter-myWriting",
            component: () => import("@/views/writingCenter/myWriting/index.vue"),
            meta: {
                isLogin: true,
            },
        },
        {
            path: "/writingCenter/library",
            name: "writingCenter-library",
            component: () => import("@/views/writingCenter/library/index.vue"),
            meta: {
                isLogin: true,
            },
        },
        {
            path: "/writingCenter/outline",
            name: "writingCenter-outline",
            component: () => import("@/views/writingCenter/outline.vue"),
            meta: {
                isLogin: true,
            },
        },
        {
            path: "/writingCenter/summarize",
            name: "writingCenter-summarize",
            component: () => import("@/views/writingCenter/summarize.vue"),
            meta: {
                isLogin: true,
            },
        },
        {
            path: "/writingCenter/paper",
            name: "writingCenter-paper",
            component: () => import("@/views/writingCenter/paper.vue"),
            meta: {
                isLogin: true,
            },
        },
        {
            path: "/writingCenter/ai-questionsAndAnswers",
            name: "writingCenter-ai-questionsAndAnswers",
            component: () => import("@/views/writingCenter/ai-questionsAndAnswers.vue"),
            meta: {
                isLogin: true,
            },
        },
        {
            path: "/writingCenter/contributionAnalysis",
            name: "writingCenter-contributionAnalysis",
            component: () => import("@/views/writingCenter/contributionAnalysis/index.vue"),
            meta: {
                isLogin: true,
            },
        },
    ]
}